import { Injectable } from '@angular/core';
import { CompetitionInitService } from '../../services/competition-init.service';

@Injectable({
  providedIn: 'root'
})
export class CompetitionDocumentsFilterService {

  constructor(public competition_general_service: CompetitionInitService) {

  }

  /**
   * Method for get the store wrapped.
   *
   * @readonly
   * @memberof CompetitionDocumentsFilterService
   */
  get store() {
    return this.competition_general_service.competitionDocumentsStore;
  }

  /**
   *
   *
   * @readonly
   * @memberof CompetitionDocumentsFilterService
   */
  get data() {
    return this.store.data && this.store.data[0] ? this.store.data[0] : undefined;
  }
}
